export interface IResponseGoogleMapsSettings {
  google_api_key: string;
  google_api_key_private: string;
}

export const googleMapsSettingsCast = (data: IResponseGoogleMapsSettings) => ({
  publicGoogleApiKey: String(data.google_api_key || ''),
  privateGoogleApiKey: String(data.google_api_key_private || ''),
});

export type TGoogleMapsSettings = ReturnType<typeof googleMapsSettingsCast>;
